import React, { Fragment } from 'react';
import { Text, View, StyleSheet, Image } from '@react-pdf/renderer';
import logo from "../../Asset/react-pdf-icon.png";
import InvoiceTitle from "./InvoiceTitle";
import PdfDocument from './Invoice';

const styles = StyleSheet.create({
    invoiceNoContainer: {
        marginTop: 36,
        border: '3px solid #0B5F68',
        height: '200px',
        width: '400px',
        marginLeft: 'auto',
        marginRight: 'auto',
    },
    invoiceDateContainer: {
        flexDirection: 'row',
        justifyContent: 'flex-end'
    },
    invoiceDate: {
        fontSize: 12,
        fontStyle: 'bold',
    },
    label: {
        width: 60
    },
    logo: {
        width: 90,
        height: 90,
        marginLeft: 'auto',
        border: '2px solid #0B5F68',
        marginTop: 20,
        marginRight: 20,
    },
    heading: {
        backgroundColor: '#0B5F68',
        width: '350px',
        height: '40px',
        marginTop: 10,
        marginLeft: 'auto',
        marginRight: 'auto',
        textAlign: 'center',
        paddingTop: 10, // Removed the quotes to make it a number
        color: 'white',
      fontFamily:'Helvetica-Bold', // Use numeric value for bold
        fontSize: 20, // Use numeric value for font size
    }
});

const InvoiceNo = () => {
   let img=localStorage.getItem('uPic');
 return(
   <Fragment>
        <View style={styles.invoiceNoContainer}>
            <Text style={styles.heading}>ID Card</Text>
            <Image style={styles.logo} src={img} />
        </View>
    </Fragment>
 );
}

export default InvoiceNo;
